module.exports = __webpack_public_path__ + "assets/media/drift-bolts.e07a5128.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/drift-bolts.svg
// module id = 1055
// module chunks = 0